module.exports = __webpack_public_path__ + "assets/2c2e14356b07e9b97bca36df29178285.mp4";